<template>
  <vxe-modal ref="modal" size="mini" v-model="formVisible" title="选择员工" width="300px" @show="showModal">
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
      <el-form-item prop="person">
        <el-select clearable :multiple="isMultiple" filterable v-model="form.person" size="small" placeholder="请选择">
          <el-option v-for="i of employeeOptions" :key="i + ''" :label="i" :value="i"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button @click="handleCommit" style="float: right; margin-top: 10px" size="mini" type="primary">确认</el-button>
  </vxe-modal>
</template>
<script>
export default {
  props: {
    // 是否支持多选
    isMultiple: {
      type: Boolean,
      default: true
    },
    // 过滤条件
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formVisible: false,
      // 当前选择人员值（可多选）
      form: {
        person: []
      },
      rules: {
        // date: [
        //   { required: true, message: '请选择日期', trigger: 'change' }
        // ]
      },
      // employeeOptions: [{ name:'', value:''}]
      employeeOptions: []
    }
  },
  methods: {
    showModal() {
      this.list()

      this.setRules()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    openModal(persons) {
      if (this.isMultiple) {
        if (persons) {
          this.form.person = persons.split(',')
        } else {
          this.form.person = []
        }
      } else {
        this.form.person = persons
      }

      this.formVisible = true
    },
    // 根据是否必填来配置校验规则
    setRules() {
      if (this.isRequired) {
        this.rules = {
          person: [{ required: true, message: '请选择人员', trigger: 'change' }]
        }
      }
    },
    async list() {
      this.employeeOptions = []
      const { data: res } = await this.$http.get('/finance/users')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data) {
        // let cache = {
        //   name: item.name,
        //   // 标识@员工编号@姓名@岗位
        //   value: item.id + '@' + item.name + '@' + item.role
        // }
        // this.employeeOptions.push(cache)

        this.employeeOptions.push(item.name)
      }
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      // 分割 person 构造出对象进行返回，原值为 id@账号@名字@岗位
      // 1.单选：直接返回对象
      // 2.多选：返回数组对象
      let res
      // 只选了单个人
      if (typeof this.form.person === 'string') {
        res = this.form.person
      } else {
        res = []
        // 数组类型，说明选择了多个人
        this.form.person.forEach(v => {
          res.push(v)
        })
      }
      this.$emit('sureBackPerson', res)
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
.el-form-item {
  margin: 0 !important;
}
</style>
